export class Constant {
  public static readonly PREFIX_URL = "/";
  public static readonly LANGUAGE = "lang";
  public static readonly ENGLISH = "en";
  public static readonly SOUTH_KOREA = "kr";
  public static readonly VIETNAM = "vn";

  public static readonly STATUS_USER = "01";
  public static readonly NOT_ACTIVATED = "01-01";
  public static readonly ACTIVATED = "01-02";
  public static readonly DISABLED = "01-03";

  public static readonly ACTIVE_STATUS_VAL = "Y";
  public static readonly INACTIVE_STATUS_VAL = "N";

  public static readonly SECURITY_MODES_TCP = "04";

  public static readonly SECURITY_MODES_HTTPS = "05";

  public static readonly SECURITY_POLICIES = "06";

  public static readonly UA_CONNECT_TP = "07";

  public static readonly CONNECTION_PROTOCOL_TYPE = "02";

  public static readonly DEVICE_CONNECT_STATUS = "08";

  public static readonly CONNECTION_STATUS = "11";

  public static readonly DELIVERY_TYPE = "03";

  public static readonly FORMAT_DATE_EN = "YYYY-MM-DD";
  public static readonly START_PAGE = 1;
  public static readonly ROWS_OF_PAGE = 10;

  public static readonly LABEL_KR = "labelKr";
  public static readonly LABEL_EN = "label";

  public static readonly COMM_NM_KR = "commNm";
  public static readonly COMM_NM_EN = "commNmEn";

  public static readonly PRIME_FORMAT_DATE_EN = "dd-mm-yy";
  public static readonly PRIME_FORMAT_DATE_KR = "yy-mm-dd";
  public static readonly PRIME_FORMAT_DATETIME_EN = "dd-mm-yyyy hh:mm";
  public static readonly PRIME_FORMAT_DATETIME_KR = "yyyy-mm-dd hh:mm";

  public static readonly ACTIVE_STATUS = "Active";
  public static readonly INACTIVE_STATUS = "Inactive";
  public static readonly DISABLED_STATUS = "Disabled";
  public static readonly LOCK_STATUS = "Lock";

  public static readonly GET_METHOD = "GET";
  public static readonly POST_METHOD = "POST";
  public static readonly PUT_METHOD = "PUT";
  public static readonly DELETE_METHOD = "DELETE";

  public static readonly VAPID_KEY = "BFokkHJnVqsqDrYgkzVzP8SxZst5ZUBiFrrNzkxKmAn-Qo027tNEe2OKBWOU0iMtITegf7O7jgyArli6Z59IJgc";
  public static readonly FIREBASE_CONF = {
    apiKey: "AIzaSyDWyxxGiyS0fGcde6lh-KwNJxgP-2ExRZ4",
    authDomain: "egov-test-58837.firebaseapp.com",
    projectId: "egov-test-58837",
    storageBucket: "egov-test-58837.appspot.com",
    messagingSenderId: "263590623306",
    appId: "1:263590623306:web:ef41bb4c6cd840ec8a0eb3",
  };

  public static readonly PUBLIC_KEY = "PublicKey";

  public static readonly LST_ROW_OF_PAGE = [
    {
      label: "10 rows",
      labelKr: "10개 ",
      value: 10
    },
    {
      label: "15 rows",
      labelKr: "15개 ",
      value: 15
    },
    {
      label: "20 rows",
      labelKr: "20개 ",
      value: 20
    },
    {
      label: "30 rows",
      labelKr: "30개 ",
      value: 30
    }
  ];
}
